import Home from '@/components/common/Home.vue';

export const sourceRoutes = {
  path: '/source',
  component: Home,
  name: 'Source',
  redirect: '/source/overall',
  meta: {
    title: 'Source',
  },
  children: [
    {
      path: 'add',
      meta: {
        title: 'Add',
      },
      component: () => import('@/views/dashboard/index.vue'),
    },
    {
      path: 'overall',
      component: () => import('@/views/source/sourceOverall.vue'),
      meta: {
        title: 'Source Overall',
      },
    },
    {
      path: 'detail',
      meta: {
        title: 'Source Detail',
      },
      component: () => import('@/views/source/sourceDetail.vue'),
    },
  ],
};
